import { ACCOUNTING_ROLES, type BookkeepingPacket, type BookkeepingPreview } from '@tcvs/shared';

/** Review worksheet, deliberately not a Business Central journal import layout. */
export function bookkeepingCsv(report: BookkeepingPreview | BookkeepingPacket): string {
  const packet = 'packetId' in report ? report : undefined;
  const header = [
    'Review only - not a BC import',
    'Review month',
    'Packet ID',
    'Status',
    'Source ID',
    'Source version',
    'Source date',
    'Prior period',
    'Proposed account role',
    'Debit USD',
    'Credit USD',
    'Payment reference',
    'Source fingerprint',
  ];
  const rows = report.sources.flatMap((s) =>
    (s.entries.length ? s.entries : [{ role: undefined, debitMinor: 0, creditMinor: 0 }]).map(
      (e) => [
        'Manual accounting review',
        report.month,
        packet?.packetId ?? 'UNSAVED',
        packet?.status ?? 'PREVIEW',
        s.sourceId,
        String(s.version),
        s.date,
        s.priorPeriod ? 'Yes' : 'No',
        e.role ? ACCOUNTING_ROLES[e.role] : 'No monetary change',
        (e.debitMinor / 100).toFixed(2),
        (e.creditMinor / 100).toFixed(2),
        s.paymentReference ?? '',
        s.sourceFingerprint,
      ],
    ),
  );
  const cell = (v: string) => `"${(/^[\s]*[=+\-@]/.test(v) ? `'${v}` : v).replaceAll('"', '""')}"`;
  return [header, ...rows].map((r) => r.map(cell).join(',')).join('\r\n');
}
